<template>
	<div class="home_wrapper">
		<div class="home_container">
			<AllGamesBannerPc msg="This is views-pc-HomeView" />

			<ContactUsPc v-if="isHideForTest" />
		</div>

		<div class="all_games_container" v-lazy:background-image="require('@/assets/static/imgs/home/bg-player.png')">
			<div class="all_games_gradient_1">
				<div class="menu_top">
					<div 
						class="menu_top_item" 
						v-for="(item, index) in openMenu" :key="item" 
						v-if="index > 0" 
						:class="{ active: index === currentOpenMenuIndex }" 
						@mouseenter="showGameFromTypeBottom(index)">
						<div>{{ item }}</div>
						<div></div>
					</div>
				</div>

				<div class="menu_bottom ">
					<div 
						class="menu_bottom_item" 
						v-for="(item, index) in allGames" :key="currentOpenMenuIndex + '-' + index + '-' + item.game_id" 
						v-if="item.visible" 
						@click="gotoGameDetail(item.game_id)">
						<img v-lazy="item.icon" alt="" />
						<div v-if="false">{{ item.game_name }}</div>
					</div>
					<div class="menu_bottom_item"></div>

					<div 
						class="menu_cross_line" 
						v-for="(itemLine, i) in crossLines" :key="i" 
						:class="'menu_cross_line_box_' + i">
						<div 
							class="menu_cross_line_item" 
							v-for="(itemCross, j) in 5" :key="i + '-' + j" 
							:class="'menu_cross_line_item_' + j"></div>
					</div>
				</div>
			</div>
		</div>

		<BusinessCooperationPc />

		<FooterMenuPc />

		<!-- DEMO -->
		<DemoDialogPc />
	</div>
</template>

<script>
/**
 * Pc AllGamesView
 * @ is an alias to /src
 */
import { mapState }          from 'vuex';
import AllGamesBannerPc      from '@/components/pc/AllGamesBanner.vue';
import BusinessCooperationPc from '@/components/pc/BusinessCooperation.vue';
import ContactUsPc           from '@/components/pc/ContactUs.vue';
import FooterMenuPc          from '@/components/pc/FooterMenu.vue';
import DemoDialogPc          from '@/components/pc/DemoDialog.vue';
import { fetchAllGamesCached } from '@/api/gameDataLoader';
import {
    NAV_IS_PAGE_SCROLL,
    CURRENT_GAME_ID,
    DEMO_DIALOG_IS_SHOW
} from '@/type/mutation';

export default {
	name      : 'AllGamesViewPc',
	components: {
		AllGamesBannerPc,
		BusinessCooperationPc,
		ContactUsPc,
		FooterMenuPc,
		DemoDialogPc
	},

	data() {
		return {
			// 父级容器背景图
			// homeContainerBackgroundImage: require('../../assets/static/imgs/home/banner-bg.png'),
			// homeContainerBackgroundImage: require('../../assets/static/imgs/home/index-bg-b1.png'),
			currentOpenMenuIndex  : 0,
			currentOpenMenuContent: [],
			openMenu: [
				this.$t('index.sub_nav.tit_0'),
				this.$t('index.sub_nav.tit_1'),
				this.$t('index.sub_nav.tit_2'),
				this.$t('index.sub_nav.tit_3'),
				this.$t('index.sub_nav.tit_4')
			],
			allGames      : [],
			allGamesSource: []
		};
	},

	mounted() {
		// console.log('=== Pc AllGamesView mounted <<<');

		window.scrollTo(0, 0);

		// 动态添加背景图
		// this.addBackgroundImage();

		// 监听页面滚动
    	window.addEventListener('scroll', this.handleScroll);

		// 默认加载：本地缓存优先，无则请求
		this.loadAllGames();
	},

	methods: {
		// 动态添加背景图
		addBackgroundImage()
		{
			const container                = document.querySelector('.home_container');
			// container.style.background  = `rgba(162, 112, 234, .2) url(${this.homeContainerBackgroundImage}) center bottom no-repeat`;
			container.style.background     = `url(${this.homeContainerBackgroundImage}) top center no-repeat`;
			container.style.backgroundSize = `cover`;
		},

		// 监听页面滚动
		handleScroll()
		{
			let scrollTop = document.documentElement.scrollTop || document.body.scrollTop
	        if(scrollTop)// 如果滚动距离大于0，则显示导航栏背景色
			{
				this.$store.commit(NAV_IS_PAGE_SCROLL, true);
	      	}
			else if(scrollTop === 0)// 如果滚动距离等于0，则显示导航栏背景色
			{
				this.$store.commit(NAV_IS_PAGE_SCROLL, false);
	      	}
		},

		// 二级页面点击导航，打开DEMO弹窗
		openDemoDialog(value)
		{
			this.$store.commit(DEMO_DIALOG_IS_SHOW, value);
		},

		// 切换显示不同地区的GAMES
		showGameFromTypeBottom(index)
		{
			this.currentOpenMenuIndex = index;
			this.allGames             = [];
			if(index === 0)// ALL
			{
				this.allGames = this.allGamesSource.filter(game => game.visible === true);
			}
			else if(index > 0)// Others
			{
				this.allGames = this.allGamesSource.filter(game => Number(game.category) === index);
				switch(index)
				{
					case 1:
					case 2:
					case 3:
					case 4:
						this.allGames.sort((a, b) => Number(b.game_id) - Number(a.game_id));
						break;
					default:
						break;
				}
			}
		},

		// 加载 allGames（缓存优先，无则请求）
		async loadAllGames()
		{
			try {
				const data = await fetchAllGamesCached();
				this.allGamesSource = (data || []).map(g => ({ ...g, visible: true }));
				this.showGameFromTypeBottom(0);
			} catch (err) {
				console.error('=== AllGamesView__loadAllGames__load failed >>>', err);
			}
		},

		// 跳转到游戏详情页
		gotoGameDetail(currentGameId)
		{
			// console.log('=== gotoGameDetail__currentGameId >>>', currentGameId);
			// this.$store.commit(CURRENT_GAME_ID, currentGameId);

			let sign = this.$Common.makeSign(this, currentGameId);
			this.$router.push({
				path: `/gamedetail/${currentGameId}/${sign}`
			});
		},

		handleError(event)
        {
            /* console.log('event >>>', event);
            event.target.src = require('@/assets/static/imgs/common/google-cloud.png'); */
        },

		/**
		 * 计算 left 值
		 * 暂未启用
		 * :style="{ left: floatLeft(index) }"
		 */
		floatLeft(index)
		{
			return `${index * 240}px`;
		}
	},

	computed: {
		// ES6展开合并运算符
		...mapState(['isHideForTest']),

		// 计算横线数量
		crossLines()
		{
			let showLines    = 1;// 默认当前显示的行数
			let oneLines     = 6;// 一行显示多少个ICON（一行阴影，显示的是12个ICON）
			if(this.allGames.length > 0)
			{
				let visibleGames = this.allGames.filter(game => game.visible === true);// 过滤出 visible 属性为 true 的游戏
				let games        = visibleGames.length;// 可见游戏的数量
				if(games > oneLines*2)
				{
					showLines = Math.floor(games / oneLines);// 例：n = 向下取整(19 / 6);
				}
			}
			return showLines;
		}
	},

	beforeDestroy() {
		window.removeEventListener("scroll", this.handleScroll);
	}
}
</script>

<style lang="less" scoped>
.home_wrapper{
	width:100%;height:auto;
	padding-top:0;
}
.home_container{
	display:flex;justify-content:center;align-items:flex-start;
	width:100%;height:var(--com-base-top-container-h2);
}
.all_games_container{
	display:flex;justify-content:center;align-items:flex-start;
	width:100%;min-height:var(--com-base-top-container-h3);
	background:#E6F0FF;
	background-position:left bottom;
	background-repeat:no-repeat;
	background-size:374px 400px;
	.all_games_gradient_1{
		margin:0 auto;
		width:var(--com-base-container-w);min-height:var(--com-base-top-container-h3);
		display:flex;flex-direction:column;justify-content:flex-start;align-items:center;
		.menu_top{
			display:flex;justify-content:flex-start;align-items:center;
			gap:80px;
			width:inherit;height:116px;line-height:116px;
			padding-left:80px;
			.menu_top_item{
				display:flex;flex-direction:column;justify-content:center;align-items:center;
				cursor:pointer;
				div{
					color:var(--com-main-ft-color);
				}
				div:nth-child(1){
					padding-left:15px;padding-right:15px;
					height:50px;line-height:50px;
					font-size:var(--com-base-fz-24);font-weight:bold;text-align:center;
				}
				div:nth-child(2){
					width:30px;height:5px;
					background:transparent;border-radius:15px;
				}
			}
			.active{
				div{
					color:#1D55FF !important;
				}
				div:nth-child(2){
					background:#1D55FF;
				}
			}
		}
		.menu_bottom{
			position:relative;
			width:inherit;height:auto;/* height:720px;margin-bottom:240px; */
			display:flex;justify-content:flex-start;align-items:flex-start;flex-wrap:wrap;
			.menu_bottom_item{
				position:relative;
				border-radius:25px;
				width:240px;height:240px;
				/* display:flex;flex-direction:column;justify-content:flex-start;align-items:center; */
				display:flex;justify-content:center;align-items:center;
				img{
					width:130px;height:130px;
					border-radius:inherit;
					box-shadow:0 0 20px 0 #a1befc;
					cursor:pointer;
				}
				div{
					position:absolute;left:0;right:0;bottom:55px;margin:auto;
					padding:3px 10px;
					width:130px;height:40px;line-height:1.2;
					font-size:var(--com-base-fz-14);color:#FFF;font-weight:bold;text-align:center;
					display:flex;justify-content:center;align-items:center;
					white-space:pre-wrap;
					background:linear-gradient(to top, rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.1));
					border-radius:0 0 22px 22px;
				}
			}
			.menu_cross_line{
				position:absolute;left:0;
				width:var(--com-base-container-w);height:480px;
				display:flex;justify-content:flex-start;align-items:flex-start;
				pointer-events:none;
				.menu_cross_line_item{
					width:480px;height:480px;
					background:url(@/assets/static/imgs/common/cross.png) 0 0 repeat-x;
					background-size:479px 479px;
					position:absolute;top:0;
					pointer-events:none;
				}
				.menu_cross_line_item_0{left:0px;}
				.menu_cross_line_item_1{left:240px;}
				.menu_cross_line_item_2{left:480px;}
				.menu_cross_line_item_3{left:720px;}
				.menu_cross_line_item_4{left:960px;}
			}
			.menu_cross_line_box_0 {top:0px;}
			.menu_cross_line_box_1 {top:240px;}
			.menu_cross_line_box_2 {top:480px;}
			.menu_cross_line_box_3 {top:720px;}
			.menu_cross_line_box_4 {top:960px;}
			.menu_cross_line_box_5 {top:1200px;}
			.menu_cross_line_box_6 {top:1440px;}
			.menu_cross_line_box_7 {top:1680px;}
			.menu_cross_line_box_8 {top:1920px;}
			.menu_cross_line_box_9 {top:2160px;}
			.menu_cross_line_box_10{top:2400px;}
			.menu_cross_line_box_11{top:2640px;}
			.menu_cross_line_box_12{top:2880px;}
			.menu_cross_line_box_13{top:3120px;}
			.menu_cross_line_box_14{top:3360px;}
			.menu_cross_line_box_15{top:3600px;}
			/* IF MORE, THEN ADD MORE */
		}
	}
}
</style>
